





import { Vue, Component, Prop } from 'vue-property-decorator'
@Component
export default class PreviousButton extends Vue {
  private clickHandler () {
    this.$emit('previous')
  }
}
